import { Text, Ref, ProviderConsumer as FluentUIThemeConsumer } from "@fluentui/react-northstar";
import { MgtPersonCard, PersonCard } from "@microsoft/mgt-react";
import React from "react";
import { getClaims } from "../../../../AuthConfig";
import "../../../../mgt.module.css";
import { Portal } from "../../Wysiwyg/SlatePortal";
import { ThemeColorScheme } from "../../../common/TeamsTheme";
import { CARD_WIDTH, getCardLeft } from "./personCardPosition";

type PersonCardMentionProps = {
  mentionedEmail: string;
  element: any;
  href: string;
};

export const PersonCardMention: React.FC<PersonCardMentionProps> = ({
  mentionedEmail,
  element,
}: PersonCardMentionProps) => {
  const linkRef = React.useRef<HTMLElement>();
  const cardRef = React.useRef<HTMLDivElement | null>();
  const [showPersonCard, setShowPersonCard] = React.useState<boolean>(false);

  MgtPersonCard.config.sections.mailMessages = false;

  const cardInfo: any = {};
  if (
    /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}?$/.test(mentionedEmail)
  )
    cardInfo.userId = mentionedEmail;
  else cardInfo.personQuery = mentionedEmail;

  React.useEffect(() => {
    const el = cardRef.current;
    const rect = linkRef.current.getBoundingClientRect();
    // innerHeight, not 100vh: on iPhone Safari 100vh is ~40px taller than what is visible, so the
    // card floated clear of the mention (#35350).
    el.style.bottom = `${window.innerHeight - rect.top}px`;
    el.style.left = `${getCardLeft(rect, el.offsetWidth || CARD_WIDTH, window.innerWidth)}px`;
  }, [showPersonCard]);

  return (
    <>
      <Ref innerRef={linkRef}>
        <Text
          color="brand"
          content={element}
          onMouseOver={() => setShowPersonCard(true)}
          onMouseOut={() => {
            setShowPersonCard(false);
          }}
          className="cursor-pointer"
          atMention={
            getClaims("preferred_username", "unique_name", "oid").some(
              (x) => x.toLowerCase() == mentionedEmail.toLowerCase()
            )
              ? "me"
              : false
          }
        />
      </Ref>
      <Portal>
        {/* The portal lands on document.body, outside every ThemeColorScheme
            wrapper, so the card would get no --mgt-theme-* tokens. React context
            still crosses the portal, so read the live Fluent theme here (this also
            follows the Teams theme, which the old TikitTheme localStorage check
            missed) and let mgt.module.css map the tokens onto the card. */}
        <FluentUIThemeConsumer
          render={globalTheme => (
            <div
              className={showPersonCard ? "" : "hidden"}
              style={{ position: "fixed", zIndex: 1000, ...ThemeColorScheme(globalTheme.siteVariables) }}
              ref={cardRef}
              onMouseOver={() => setShowPersonCard(true)}
              onMouseOut={() => {
                setShowPersonCard(false);
              }}
            >
              <PersonCard {...cardInfo} />
            </div>
          )}
        />
      </Portal>
    </>
  );
};
